import React from 'react';

import { Navigate, Route, RouteObject } from '@plasma/ui.application.router';

import { allCompaniesRoutes } from './pages/all-companies';
import { allPersonnelRoutes } from './pages/all-personnel';
import { allRfqRoutes } from './pages/all-rfq';
import { areaMasterRoutes } from './pages/area-master';
import { associatedPersonnelRoutes } from './pages/associated-personnel';
import { calculatedConsumablesDemandRoutes } from './pages/calculated-consumables-demand';
import { CompanyHome } from './pages/company-home';
import { consumableLifetimeCycleRoutes } from './pages/consumable-lifetime-cycle';
import {consumableOverviewRoutes} from './pages/consumable-overview';
import {consumableQuantityEstimationRoutes} from './pages/consumable-quantity-estimation';
import { consumablesMasterRoutes } from './pages/consumables-master';
import { createNewProjectRoutes } from './pages/create-new-project';
import {currentRfqStatusRoutes} from './pages/current-rfq-status';
import { equipmentMasterRoutes } from './pages/equipment-master';
import { faqServiceSupportRoutes } from './pages/faq-service-support';
import { guideOrderRoutes } from './pages/guide-order';
import { homeScreenRoutes } from './pages/home-screen';
import { itemDocumentFinderRoutes } from './pages/item-document-finder';
import { plannedDemandPageRoutes } from './pages/planned-demand-page';
import { plantLayoutAreaDrawingsRoutes } from './pages/plant-layout-area-drawings';
import {plantLayoutEditorRoutes} from './pages/plant-layout-editor';
import {productDetailRoutes} from './pages/product-detail';
import {productFamiliesRoutes} from './pages/product-families';
import {productionFigureRoutes} from './pages/production-figure'
import { rawMaterialMasterRoutes } from './pages/raw-material-master';
import { roleBaseDesignRoutes } from './pages/role-base-design';
import{shoppingCartRoutes} from'./pages/shopping-cart';
import {uploadExcelRoutes} from './pages/upload-excel'
import {usersPageRoutes} from './pages/users-page';
import { zoneMasterRoutes } from './pages/zone-master';

export const routes: RouteObject[] = (()=> {

  //console.log("Role ID: ",sessionStorage.getItem('roleid'));

  const companyId= sessionStorage.getItem('companyID');
  const superUserRole= sessionStorage.getItem('superUserRole');

 return(
  [

  new Route({
    path: '/*',
    element: () => superUserRole === 'Ts-admin' ? ((companyId?.length && superUserRole === 'Ts-admin') ? ( <Navigate to="home-screen" replace /> ) : <Navigate to="create-new-project" replace />) : <Navigate to="home-screen" replace /> ,
  }),

  // new Route({
  //   path: '/home',
  //   element: () => (
  //     <Suspense fallback={<Skeleton active />}>
  //       <h1>This page is under construction!</h1>
  //     </Suspense>
  //   ),
  // }),

  new Route({
    path: '/company-home',
    element: CompanyHome,
    children: [],
  }),

  new Route({
    path: '/master-data',
    element: () => <masterData />
  }),


    new Route({
      path: '/user-master-data',
      element: () => <userMasterData />
    }),


   ...homeScreenRoutes,
   ...usersPageRoutes,
   ...productFamiliesRoutes,
   ...productDetailRoutes,
   ...plantLayoutEditorRoutes,
   ...consumableQuantityEstimationRoutes,
   ...consumablesMasterRoutes,
   ...areaMasterRoutes,
   ...zoneMasterRoutes,
   ...rawMaterialMasterRoutes,
   ...equipmentMasterRoutes,
   ...plantLayoutAreaDrawingsRoutes,
   ...allCompaniesRoutes,
   ...roleBaseDesignRoutes,
   ...createNewProjectRoutes ,
   ...uploadExcelRoutes,

  ...itemDocumentFinderRoutes,
  ...consumableOverviewRoutes,
  ...shoppingCartRoutes,
  ...currentRfqStatusRoutes,
  ...faqServiceSupportRoutes,
  ...allPersonnelRoutes,
  ...associatedPersonnelRoutes,
  ...allRfqRoutes,
  ...productionFigureRoutes,
  ...calculatedConsumablesDemandRoutes,
  ...consumableLifetimeCycleRoutes,
  ...plannedDemandPageRoutes,
  ...guideOrderRoutes
]);

})();
